module.exports = __webpack_public_path__ + "static/media/news-biz-review-wordplace.230acf64.jpg";